<div class="row flex">
  <div class="col s6">
    <lms-average-progress-widget
      [progress]="activeStudentsActivity?.averageProgress"
      [data]="data"
      [key]="'averageProgress'"
    ></lms-average-progress-widget>
  </div>
  <div class="col s6">
    <lms-progress-sections-widget
      [progressSections]="progressSections"
      [data]="data"
      [key]="'progressSections'"
    ></lms-progress-sections-widget>
  </div>
</div>
<div class="row">
  <div class="col s4">
    <lms-ratio-finished-widget
      [ratioFinished]="ratioFinished"
      [data]="data"
      [key]="'ratioFinished'"
    ></lms-ratio-finished-widget>
  </div>
  <div class="col s4">
    <lms-amount-widget [quantity]="activeStudentsActivity?.totalDuration / 60 / 60" [units]="totalDurationUnits">
      <div title>
        <h4 class="h4 chart-title chart-title--thin margin-none">
          {{ 'groups.dashboard.totalTrainingHours' | translate }}
          <gl-tooltip posBottom [text]="tooltipText"></gl-tooltip>
        </h4>
      </div>
    </lms-amount-widget>
  </div>

  <div class="col s4">
    <lms-amount-widget [quantity]="activeStudentsActivity?.averageDuration / 60 / 60" [units]="averageDurationUnits">
      <div title>
        <h4 class="h4 chart-title chart-title--thin margin-none">
          {{ 'groups.dashboard.averageTrainingHours' | translate }}
          <gl-tooltip posBottom [text]="secondaryTooltipText"></gl-tooltip>
        </h4>
      </div>
    </lms-amount-widget>
  </div>
</div>
